import PT from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { workflowFieldUnassign } from '~/actions/workflow';
import Field from '~/components/Workflow/shared/Field';
import Links from '~/components/Workflow/shared/Links';
import { useIntl } from 'react-intl';
import { getFieldLinksByFieldId } from '~/reducers/workflow';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import PageLayout from '~/ui/components/PageLayout/PageLayout';
import Text from '~/ui/components/Text/Text';
import { useModal } from '~/ui/hooks/modal';
import { testDocumentField, testUnassignedField } from '~/utils/workflow';

import FieldAssignmentMenu from '../FieldAssignmentMenu/FieldAssignmentMenu';

const { SidebarSectionItem } = PageLayout;

function FieldSectionItem({
  field,
  indent = 0,
  isAssigned = false,
  isWssDesignated = false,
  // connected,
  disabled,
  links,
  workflowFieldUnassign,
  errorMessage,
}) {
  const intl = useIntl();
  const fieldId = field.id;

  const isDocumentField = testDocumentField(field);

  const [deleteCustomFieldModal, showDeleteCustomFieldModal] = useModal({
    actionButton: {
      text: intl.formatMessage({
        id: 'FieldSectionItem.deleteButton',
        defaultMessage: 'Delete',
        description: 'Delete button text',
      }),
      variant: 'red',
      errorHandler: () => {},
      promise: async () => workflowFieldUnassign({ fieldId }),
    },
    content: (
      <FlexLayout flexDirection="column" space={6}>
        {links.length > 0 && (
          <FlexLayout
            bg="red-600"
            color="white"
            flexDirection="column"
            p={6}
            space={2}
          >
            <Text variant="m-dense-bold">
              {intl.formatMessage({
                id: 'FieldSectionItem.linkedFieldWarning',
                defaultMessage: 'This field is linked to an object',
                description:
                  'Warning message when field is linked to an object',
              })}
            </Text>
            <Text variant="s-spaced">
              {intl.formatMessage({
                id: 'FieldSectionItem.deleteConsequencesWarning',
                defaultMessage:
                  'Deleting the field will have consequences for the objects listed below.',
                description:
                  'Warning about consequences of deleting a linked field',
              })}
            </Text>
          </FlexLayout>
        )}
        <Links links={links} />
      </FlexLayout>
    ),
    disableAutoHide: true,
    title: intl.formatMessage(
      {
        id: 'FieldSectionItem.deleteModalTitle',
        defaultMessage: 'Delete {fieldName}',
        description:
          'Title for delete field modal. Example: fieldName = "Contract Date"',
      },
      { fieldName: field.name },
    ),
  });

  function handleUnassign() {
    if (!isDocumentField && links.length > 0) {
      showDeleteCustomFieldModal();
    } else {
      workflowFieldUnassign({ fieldId });
    }
  }

  const isActionDisabled = disabled || isWssDesignated;

  return (
    <SidebarSectionItem
      borderLeftIcon={
        isActionDisabled ? null : isDocumentField ? 'unlink' : 'trash'
      }
      indent={indent}
      onClickBorderLeftIcon={
        testUnassignedField(field) ? undefined : handleUnassign
      }
    >
      {isActionDisabled ? (
        <Field
          disabled={disabled}
          errorMessage={errorMessage}
          field={field}
          isAssigned={isAssigned}
        />
      ) : (
        <FieldAssignmentMenu
          fieldId={fieldId}
          trigger={
            <Field
              disabled={disabled}
              errorMessage={errorMessage}
              field={field}
              isAssigned={isAssigned}
            />
          }
        />
      )}
      {!isActionDisabled && deleteCustomFieldModal}
    </SidebarSectionItem>
  );
}

FieldSectionItem.propTypes = {
  field: PT.object.isRequired,
  indent: PT.number,
  isAssigned: PT.bool,
  errorMessage: PT.string,
};

function mapStateToProps({ builder, workflow }, { field }) {
  return {
    disabled: !builder.shouldEnableAllComponents,
    links: getFieldLinksByFieldId(workflow, field.id),
  };
}

export default connect(mapStateToProps, { workflowFieldUnassign })(
  FieldSectionItem,
);
